import React from 'react';
import get from 'lodash/get';

import Page from '../../../../researcher/blocks/page/page';
import { PAGES__SHAPE_ITEM } from '../../../redux/constants';

import * as css from './participant-canvas.scss';

const getKey = (currentPage) => get(currentPage, 'id', 'canvas');

const ClientCanvasView = ({ currentPage, ...rest }) => (
  <div className={css.canvas} key={getKey(currentPage)}>
    <Page {...rest} page={currentPage} />
  </div>
);

ClientCanvasView.propTypes = {
  currentPage: PAGES__SHAPE_ITEM,
};

ClientCanvasView.defaultProps = {
  currentPage: null,
};

export default ClientCanvasView;
